module.exports = __webpack_public_path__ + "img/My-IMG.bd3a9d7a.jpg";